module.exports = __webpack_public_path__ + "img/star.1ba8b4c3.svg";